import React from 'react';
import {
  Button,
  Confirm,
  Dropdown,
  Header,
  Form,
  Icon,
  Input,
  Checkbox,
  Tab,
} from 'semantic-ui-react';
import Details from './shop/details';
import Messages from '../Messages.js';
import Images from './shop/images';
import Schedules from './shop/schedules';
import { inlineStyle } from '../../styles/custom';
import { Link } from 'react-router-dom';
import PermissionsManager from '../PermissionsManager';
import VideoGalleryBlock from './pageBuilder/blocks/video_gallery_block';
import ImageGalleryBlock from './pageBuilder/blocks/image_gallery_block';

const renderPanes = (obj, languages, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.language,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  panes.push({
    menuItem: 'Gestion des images',
    render: () => (
      <Tab.Pane attached={false}>
        <Images obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });
  panes.push({
    menuItem: 'Horaires',
    render: () => (
      <Tab.Pane attached={false}>
        <Schedules obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });

  return panes;
};

const renderPlaces = (places) => {
  let _places = [{ value: null, text: '--' }];
  places.forEach((place) => {
    _places.push({ value: place.id, text: place.name });
  });
  return _places;
};

const renderCategories = (categories) => {
  let _categories = [{ value: null, text: '--' }];
  categories.forEach((category) => {
    const categoryWithFrenchLabel = category.details.find(
      (detail) => detail.language_id === 1,
    );
    _categories.push({
      value: category.id,
      text: categoryWithFrenchLabel.label,
    });
  });
  return _categories;
};

const ShopForm = ({
  obj,
  status,
  languages,
  places,
  categories,
  onChange,
  onSubmit,
  onDelete,
  videoGalleryRef,
  imageGalleryRef,
}) => {
  const placeId = obj.place
    ? typeof obj.place === 'object'
      ? obj.place.id
      : obj.place
    : null;
  const videoBlockIndex = obj.blocks.findIndex(
    (block) => block.type === 'video_gallery_block',
  );
  const imageBlockIndex = obj.blocks.findIndex(
    (block) => block.type === 'image_gallery_block',
  );

  return (
    <Form>
      <Header>Enseigne{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Messages errors={status.errors} />
      <Form.Field>
        <label>Nom de l'enseigne</label>
        <Input
          placeholder="Nom de l'enseigne"
          id="name"
          value={obj.name}
          onChange={onChange}
        />
      </Form.Field>
      <Form.Field>
        <label>Téléphone</label>
        <Input
          placeholder="Téléphone"
          id="ttPhone"
          value={obj.ttPhone ? obj.ttPhone : ''}
          onChange={onChange}
        />
      </Form.Field>
      <Form.Field>
        <label>Emplacement</label>
        {places.loading ? (
          <div>Chargement des emplacements</div>
        ) : (
          <Dropdown
            placeholder="Sélectionnez un emplacement"
            fluid
            selection
            closeOnChange
            id="place"
            value={placeId}
            options={renderPlaces(places.getPlaces)}
            onChange={(e, data) => onChange(e, data, 'dropdown')}
          />
        )}
      </Form.Field>
      <Form.Field>
        <label>Catégorie</label>
        {categories.loading ? (
          <div>Chargement des catégories</div>
        ) : (
          <Dropdown
            placeholder="Sélectionnez une catégorie"
            fluid
            selection
            closeOnChange
            id="category_id"
            value={obj.category_id}
            options={renderCategories(categories.getCategories)}
            onChange={(e, data) => onChange(e, data, 'dropdown')}
          />
        )}
      </Form.Field>
      <Form.Field>
        <Button.Group size="large">
          {obj.type === 'shop' ? (
            <Button active>
              <Icon name="cart" /> Magasin
            </Button>
          ) : (
            <Button id="shop" onClick={onChange}>
              <Icon name="cart" /> Magasin
            </Button>
          )}
          {obj.type === 'restaurant' ? (
            <Button active>
              <Icon name="food" /> Restaurant
            </Button>
          ) : (
            <Button id="restaurant" onClick={onChange}>
              <Icon name="food" /> Restaurant
            </Button>
          )}
          {obj.type === 'bien-etre' ? (
            <Button active>
              <Icon name="heart" /> Bien-Être
            </Button>
          ) : (
            <Button id="bien-etre" onClick={onChange}>
              <Icon name="heart" /> Bien-Être
            </Button>
          )}
        </Button.Group>
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Field>
          <label>Tag nouveauté</label>
          <Checkbox
            id="is_new"
            label="Afficher le tag nouveauté ?"
            checked={obj.is_new || false}
            onChange={(e, data) => onChange(e, data, 'checkbox')}
          />
        </Form.Field>
        <Form.Field>
          <label>Tag coup de coeur</label>
          <Checkbox
            id="is_heart"
            label="Afficher le tag coup de coeur ?"
            checked={obj.is_heart || false}
            onChange={(e, data) => onChange(e, data, 'checkbox')}
          />
        </Form.Field>
      </Form.Group>
      {languages.loading ? (
        <div>Chargement</div>
      ) : (
        <Tab
          menu={{ pointing: true }}
          panes={renderPanes(obj, languages.getLanguages, onChange)}
        />
      )}
      <VideoGalleryBlock
        obj={videoBlockIndex !== -1 ? obj.blocks[videoBlockIndex] : null}
        ref={videoGalleryRef}
      />
      <ImageGalleryBlock
        obj={imageBlockIndex !== -1 ? obj.blocks[imageBlockIndex] : null}
        ref={imageGalleryRef}
      />
      <br />
      <br />
      <Form.Field>
        {status.loading ? (
          <Button type="submit" floated="left" color="red" loading>
            {' '}
            Chargement...
          </Button>
        ) : (
          <PermissionsManager hasPermissions={['create_shop', 'update_shop']}>
            <Button
              type="submit"
              floated="left"
              color="olive"
              onClick={onSubmit}
            >
              <Icon name="save" /> Sauvegarder
            </Button>
          </PermissionsManager>
        )}
        {!status.isNew ? (
          <div>
            <PermissionsManager
              hasPermissions={[
                'create_social_network',
                'update_social_network',
                'delete_social_network',
              ]}
            >
              <Link
                to={`/shops/${obj.id}/social-networks`}
                floated="right"
                className="ui button olive"
              >
                <Icon name="discussions" /> Gestion des réseaux sociaux
              </Link>
            </PermissionsManager>
            <PermissionsManager hasPermissions={['delete_shop']}>
              <Button
                type="submit"
                color="red"
                floated="right"
                onClick={(event, data) => {
                  onDelete(event, { confirm: true });
                }}
              >
                <Icon name="delete" /> Suppression
              </Button>
            </PermissionsManager>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer cette enseigne ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(event, data) => {
          onDelete(event, { confirm: null });
        }}
        onConfirm={(event, data) => {
          onDelete(event, { confirm: false });
        }}
        style={inlineStyle.modal}
        cancelButton="Annuler"
        confirmButton="Ok"
      />
    </Form>
  );
};

export default ShopForm;



// WEBPACK FOOTER //
// ./src/components/form/Shop.js